import React from "react";
import IdleTimer from "react-idle-timer";
import { UserData } from "../../api";

class IdleTimerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.idleTime = 60 * 10 * 60 * 15;
        this.idleTimer = null;
        this.handleOnIdle = this.handleOnIdle.bind(this);
        this.handleOnActive = this.handleOnActive.bind(this);
    }

    handleOnIdle(event) {
        UserData().then((response) => {});
    }
    handleOnActive(event) {
        UserData().then((response) => {});
    }

    render() {
        return (
            <div>
                <IdleTimer
                    ref={(ref) => {
                        this.idleTimer = ref;
                    }}
                    timeout={this.idleTime}
                    onIdle={this.handleOnIdle}
                    onActive={this.handleOnActive}
                    debounce={0}
                />
            </div>
        );
    }
}

export default IdleTimerComponent;
